systemSettingsIntroScreenButton = {};

systemSettingsIntroScreenButton.create = function() {
    var button = new PIXI.Container();
    
    InputHelpers.addGenerics(button);
    InputHelpers.addCanSpinFlag(button);
	
    button.canEnable = function() {
    	return true;
    };
    
    button.onPressedCallback = function() {

    };

    return button;
};

systemSettingsIntroScreenButton.initialise = function(json, object) {
	object.soundName = json.soundName || "";
};
systemSettingsIntroScreenButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("systemSettingsIntroScreenButton", systemSettingsIntroScreenButton.create, systemSettingsIntroScreenButton.initialise, systemSettingsIntroScreenButton.getFilesRequired);